// Copyright (C) 2025, Lifefinder Systems International AB, all rights reserved.
import React from 'react';

import { useAuth } from '../../../context/AuthContext';

import { resolveGuide } from './guides';

/**
 * OperatingGuide Component
 *
 * Renders the operating guide selected for the account (a self-contained HTML
 * document with its own styles and scripts) inside an iframe. The guide is chosen
 * by a SuperAdmin and delivered via the auth payload; it resolves to a static
 * asset served from `public/operatingGuide/`. Falls back to the default guide
 * when no selection (or an unknown id) is present.
 *
 * Shown as a sub-view of the Devices category in the Maintenance window,
 * alongside "Warnings" and "Device Maintenance".
 */
export const OperatingGuide: React.FC = () => {
  const { operatingGuide } = useAuth();
  const guide = resolveGuide(operatingGuide);
  const src = `${process.env.PUBLIC_URL}/operatingGuide/${guide.file}`;

  return (
    <div
      style={{
        background: 'white',
        borderRadius: '1vmin',
        border: '1px solid #ddd',
        overflow: 'hidden',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      }}
    >
      <iframe
        key={guide.id}
        src={src}
        title={`${guide.label} Operating Guide`}
        style={{
          display: 'block',
          width: '100%',
          height: 'calc(100vh - 28vmin)',
          minHeight: '400px',
          border: 'none',
        }}
      />
    </div>
  );
};

export default OperatingGuide;
